import { Stack } from "@mui/material"
import { CatLoader } from "components/layout/CatLoader";
import RandomQuestions from "components/layout/RandomQuestions";

export const LoadingAIForm = () => {
    return <Stack gap={2} alignItems="center" justifyContent="center" py={5}>
        <CatLoader />
        <RandomQuestions title="Did you know?"></RandomQuestions>
    </Stack>
};